<template>
  <div v-style="{ bg: backgroundColor, h: bottomMargins }" class="flex items-center overflow-hidden">
    <hr
      v-if="divider"
      v-style:bg="dividerColor"
      class="w-full b-none bg-current"
      :style="{ height: thicknessMapping[dividerThickness] }"
    >
  </div>
</template>

<script lang="ts" setup>
import type { Spacer } from '#types/components/cms/spacer'

const { content } = defineProps<{ content: Spacer }>()

const thicknessMapping: Record<'small' | 'medium' | 'large', string> = {
  small: '1px',
  medium: '2px',
  large: '3px'
}

const { backgroundColor, bottomMargins, divider, dividerColor, dividerThickness = 'small' } = content
</script>
